'use strict'

/**
 * @overview axios 请求封装
 * @author  yh.qin
 */

import axios from 'axios'
import COMMON from './common/common.api'
// import utils from "@/utils";
import store from '@/store'
import whiteList from './whiteList'
// axios 可以使用 axios.create 创建不同的接口配置

// axios.defaults.baseURL = ""
// 响应时间
axios.defaults.timeout = 5*60*1000
;(axios.defaults.maxRedirects = 10), //允许最大http重定向数
  // 设置默认请求头
  (axios.defaults.headers = {
    'Content-Type': 'application/json; charset=UTF-8',
  })
let url
// 添加请求拦截器
axios.interceptors.request.use(
  (config) => {
    url = config.url
    let runWhite = /\/runcode|\/pj\/run/.test(url)
    const cancelToken = whiteList.tokenCancel(url)
    const cancelTenantId = whiteList.tenantIdCancel(url)
    let token = store.state.token
    let tenantId = store.state.tenantId
    if (token) token = token.replace(/'|"/g, '')
    let reg_text_url = /.*txt$/

    if (!cancelToken && !runWhite && !reg_text_url.test(url)) {
      config.headers.token = token || ''
    }
    // 请求体添加租户id
    if (!cancelTenantId && config.data) {
      if (config.data instanceof Array) {
        let data = config.data
        config.data = data.map((item) => {
          item.tenantId = tenantId
          return item
        })
      } else {
        config.data.tenantId = tenantId
      }
    }

    return config
  },
  (error) => {
    // window.vm.$toast.clear();
    // console.log("error:", error);
    return Promise.reject(error)
  }
)

// 添加返回拦截器
axios.interceptors.response.use(
  (response) => {
    // window.vm.$toast.clear();
    // console.log("response:", response);
    const result = response.data
    // if (result.Status === 200) {
    //   // if (
    //   //   result.Data.Status === 32 ||
    //   //   result.Data.Status === 33 ||
    //   //   result.Data.Status === 401
    //   // ) {
    //   //   // getToken();
    //   // } else if (result.Data.Status === 35 || result.Data.Status === 36) {
    //   //   // store.commit("sessionId", "");
    //   //   // window.vm.$router.replace({
    //   //   //   name: "login"
    //   //   // });
    //   // }
    //   return result.Data;
    // } else if (result.Status === 403) {
    //   getToken();
    // } else {
    //   checkCode(result.ErrorMessage);
    // }

    let token = store.state.token
    if (result.isSuccess || response.status === 200 || !token) {
      if (result.returnCode == 401) {
        let { pathname } = window.location
        if (pathname != '/' && pathname != '/home') {
          window.location.href = '/'
        }
        localStorage.loginType = '1'
      }
    } else {
      checkCode(result.ErrorMessage)
    }

    return result
  },
  (error) => {
    // window.vm.$toast.clear();
    error.message = '无法连接服务器'
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误'
          break
        case 401:
          error.message = '访问失败，请重试'
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          error.message = '请求失败'
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器内部错误'
          break
        case 501:
          error.message = '服务未实现'
          break
        case 502:
          error.message = '无法连接服务器'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '连接服务器超时'
          break
        case 505:
          error.message = 'HTTP版本不受支持'
          break
        default:
      }
    }
    checkCode(error.message)
  }
)

// 请求失败错误信息提示
/**
 * TODO:
 * @param {} message
 */
function checkCode(message) {
  // 弹出错误信息
  // window.vm.$toast(message);
  console.error(message)
}

// token 处理
function getToken() {
  // testLogin();
}

export default axios
